/**
 * Metadata extracted from a decorator's context to identify its target.
 */
export interface DecoratorInfo {
  /** Whether the decorator is applied to a class definition. */
  isClass: boolean;
  /** The name of the property or method the decorator is applied to. */
  key?: string;
}

/**
 * Normalizes decorator context for both TypeScript and Babel environments.
 * 
 * @param key - The decorator's target context (property name or Babel descriptor).
 * @returns {@link DecoratorInfo} describing the target.
 */
export const getDecoratorInfo = (key: any): DecoratorInfo => {
  // babel
  if (key instanceof Object) {
    return {
      isClass: key.kind === 'class',
      key: key.name
    };
  }

  // typescript
  if (key == undefined) {
    return { isClass: true };
  };

  return { isClass: false, key };
}
